import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-detail',
	path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
	exact: true,
};
